/** @jsx jsx */
import { jsx } from '@emotion/core';
import { FunctionComponent, ReactElement } from 'react';
import * as styles from './styles';

export interface IProps {}

jsx;
export const Footer: FunctionComponent<IProps> = ({ children, ...props }): ReactElement<IProps> => {
  return (
    <div css={styles.footer} {...props}>
      {children}
    </div>
  );
};

export default Footer;
